import { createSelector } from '@ngrx/store';

import { selectEBillState, State } from '@ruby/modules/ebill/store';
import * as fromEBillLocations from '@ruby/modules/ebill/store/reducers/ebill-locations.reducer';
import { selectUserRacf } from '@ruby/modules/security/store/selectors/authorizations.selectors';

export const selectBillLocationState = createSelector(
  selectEBillState,
  selectUserRacf,
  (state: State, userRacf?: string) => ({ state: state[fromEBillLocations.featureKey], userRacf })
);

